import { useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { Event } from '../types/Event';
import { useAuth } from '../contexts/AuthContext';

export interface Participant {
  id: string;
  name: string; // Gardé pour compatibilité, contient Prénom + Nom
  firstName?: string;
  lastName?: string;
  nickname?: string;
  team?: string;
  city?: string;
}

export const useParticipants = () => {
  const { user } = useAuth();
  const [participants, setParticipants] = useState<Participant[]>([]);
  const [loadingParticipants, setLoadingParticipants] = useState(false);
  const [participantsDialogOpen, setParticipantsDialogOpen] = useState(false);

  const fetchParticipants = async (eventId: string, participantIds: string[]) => {
    try {
      setLoadingParticipants(true);
      const participantsData: Participant[] = [];

      for (const participantId of participantIds) {
        const userDocRef = doc(db, 'users', participantId);
        const userDocSnap = await getDoc(userDocRef);

        if (userDocSnap.exists()) {
          const userData = userDocSnap.data();
          const fullName = `${userData.firstName || ''} ${userData.lastName || ''}`.trim();

          participantsData.push({
            id: participantId,
            name: fullName || userData.nickname || 'Utilisateur',
            firstName: userData.firstName,
            lastName: userData.lastName,
            nickname: userData.nickname || '',
            team: userData.team || '',
            city: userData.city || ''
          });
        }
      }

      setParticipants(participantsData);
    } catch (error) {
      console.error('Erreur lors de la récupération des participants:', error);
    } finally {
      setLoadingParticipants(false);
    }
  };

  const handleParticipantsClick = (event: React.MouseEvent, eventData: Event) => {
    event.stopPropagation();

    if (eventData.participants && eventData.participants.length > 0) {
      fetchParticipants(eventData.id || '', eventData.participants);
      setParticipantsDialogOpen(true);
    }
  };

  return {
    participants,
    loadingParticipants,
    participantsDialogOpen,
    setParticipantsDialogOpen,
    handleParticipantsClick,
    fetchParticipants
  };
};
